import React from 'react'
import { RadioButton } from 'primereact/radiobutton'

import '../../../../../../components/CustomRadioButton/CustomRadioButton.css'

// Mesmo visual do CustomRadioButton, mas com name/inputId únicos por grupo
export default function RadioGroup({ nome, items, value, onChange, disabled = false }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', rowGap: 6 }}>
      {items.map(item => {
        const inputId = `${nome}-${item.value}`
        return (
          <span
            key={item.value}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              whiteSpace: 'nowrap',
              marginRight: 15,
            }}
          >
            <RadioButton
              inputId={inputId}
              name={nome}
              value={item.value}
              disabled={disabled}
              onChange={e => onChange(e.value)}
              checked={value === item.value}
            />
            <label htmlFor={inputId} className="p-radiobutton-label">
              {item.label}
            </label>
          </span>
        )
      })}
    </div>
  )
}
